// theme.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private isDarkMode$ = new BehaviorSubject<boolean>(false);

  setTheme(isDark: boolean) {
    this.isDarkMode$.next(isDark);
  }

  getTheme() {
    return this.isDarkMode$.asObservable();
  }
}
